const normalize = str =>
  str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

const keywordMaps = {
  en: {
    teams: 'team',
    name: 'name',
    area: 'department',
    code: 'code',
    position: 'jobTitle',
    location: 'location',
    report: 'reportsTo',
    division: 'division',
    tags: 'tags',
  },
  es: {
    equipos: 'team',
    nombre: 'name',
    area: 'department',
    codigo: 'code',
    posicion: 'jobTitle',
    localizacion: 'location',
    relacionado: 'reportsTo',
    division: 'division',
    etiquetas: 'tags',
  },
  ca: {
    equips: 'team',
    nom: 'name',
    area: 'department',
    codi: 'code',
    posicio: 'jobTitle',
    localitzacio: 'location',
    relacionat: 'reportsTo',
    divisio: 'division',
    etiquetes: 'tags',
  },
  eu: {
    taldeak: 'team',
    izena: 'name',
    saila: 'department',
    kodea: 'code',
    lanpostua: 'jobTitle',
    kokapena: 'location',
    erreferentzia: 'reportsTo',
    atala: 'division',
    etiketak: 'tags',
  },
  pt: {
    equipas: 'team',
    nome: 'name',
    area: 'department',
    codigo: 'code',
    posicao: 'jobTitle',
    localizacao: 'location',
    relacionado: 'reportsTo',
    divisao: 'division',
    etiquetas: 'tags',
  },
};

export const searchFields = [
  'team',
  'name',
  'department',
  'code',
  'jobTitle',
  'location',
  'reportsTo',
  'division',
  'tags',
];

export const getLocalizedKeyword = (dbField, locale) => {
  const map =
    keywordMaps[locale] || (locale && keywordMaps[locale.split('-')[0]]) || keywordMaps.en;
  return Object.entries(map).find(([, v]) => v === dbField)?.[0] || dbField;
};

const allKeywordsMap = {};
for (const map of Object.values(keywordMaps)) {
  for (const [key, val] of Object.entries(map)) {
    allKeywordsMap[normalize(key)] = val;
  }
}

export const getFieldFromKeyword = keyword =>
  keyword ? allKeywordsMap[normalize(keyword)] || null : null;

export const translateSearchKeywords = searchString => {
  return searchString.replace(/(\S+?):((?:"[^"]*")|\S*)/g, (full, keyword, value) => {
    const dbField = allKeywordsMap[normalize(keyword)];
    if (!dbField) return full;
    const isQuoted = value.startsWith('"') && value.endsWith('"');
    if (isQuoted) {
      const inner = value.slice(1, -1);
      if (inner.endsWith('*')) return `${dbField}:${value}`;
      return `${dbField}:"=${inner}"`;
    }
    return `${dbField}:${value}`;
  });
};
